import React, { useCallback, useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import LayoutPage from "../Layout";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import DeleteConfirmation from "../shared/DeleteConfirmation";
import { Switch } from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import Calendar from "react-calendar";
import "../../styles/custom.css";
import "react-calendar/dist/Calendar.css";
import moment from "moment";
// import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateRangePicker } from "@mui/x-date-pickers-pro/DateRangePicker";
import Swal from "sweetalert2";
import {
  arrayMove,
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { closestCenter, DndContext } from "@dnd-kit/core";
import { SortableItem } from "./SortableItems";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "../../styles/custom.css";

function Dnd() {
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [categoryData, setCategoryData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [perPage, setperPage] = useState(10);
  const [loadingDeleteModel, setLoadingDeleteModel] = useState(false);
  const [loadingDeleteModelConfirmText, setLoadingDeleteModelConfirmText] =
    useState("Deleting");
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [idBeingDeleting, setIdBeingDeleting] = useState(null);
  const [deleteModelTitle, setDeleteModelTitle] = useState("Confirm Delete");
  const [deleteModelMessage, setDeleteModelMessage] = useState(
    "Are you sure you want to delete this sport category?"
  );
  const [deleteModelActionType, setDeleteModelActionType] = useState("Delete");

  const [status, setStatus] = useState(false);
  const [update, setUpdate] = useState(false);

  let [date, changeDate] = useState(moment().format("YYYY-MM-DD"));
  // const [showCalendar, setCalendar] = useState(false);
  // const [selectedRow, setSelectedRow] = useState(null);
  // const [clickPosition, setClickPosition] = useState({ x: 0, y: 0 });
  const [calenderDate, setCalenderDate] = useState([null, null]);
  const [dateRange, setDateRange] = useState([null, null]);
  const [popup, showPopup] = useState(false);

  const navigate = useNavigate();
  const handleAppToggle = (event) => {
    // console.log("Event",event);
    // console.log("toggle", event.target.id);

    if (!event.target.checked) {
      axios
        .patch(
          `/admin/updateSportsCategoryStatus/{sportId}/{appStatus}/{webStatus}?sportId=${event.target.id}&appStatus=false`
        )
        .then((res) => {
          setStatus(Math.random());
        });
    } else {
      axios
        .patch(
          `/admin/updateSportsCategoryStatus/{sportId}/{appStatus}/{webStatus}?sportId=${event.target.id}&appStatus=true`
        )
        .then((res) => {
          setStatus(Math.random());
        });
    }
  };
  const handleWebsiteToggle = (event) => {
    // console.log(event);
    // console.log("toggle", event.target.id);

    if (!event.target.checked) {
      axios
        .patch(
          `/admin/updateSportsCategoryStatus/{sportId}/{appStatus}/{webStatus}?sportId=${event.target.id}&webStatus=false`
        )
        .then((res) => {
          setStatus(Math.random());
        });
    } else {
      axios
        .patch(
          `/admin/updateSportsCategoryStatus/{sportId}/{appStatus}/{webStatus}?sportId=${event.target.id}&webStatus=true`
        )
        .then((res) => {
          setStatus(Math.random());
        });
    }
  };
  const handleSelect = (e) => {
    navigate(`/category/${e.target.value}/${e.target.id}`);
  };

  const handleEditButton = (sportId) => {
    navigate(`/category/editcategory/${sportId}`);
  };

  const handleWinnerButton = (e) => {
    navigate("/contest-winner");
  };
  const handleCalendar = (value, e) => {
    // setCalendar(true);
    // setSelectedRow(value._id);
    // console.log(date)
    // changeDate(date)
    // console.log(e);
    // console.log(e.clientX,e.clientY)
    // setClickPosition({ x: e.clientX, y: e.clientY });

    console.log(value._id);
  };

  // const handleDate = (date) => {
  //   changeDate(date);
  //   showPopup(true);
  //   // setCalendar(false);
  // };

  const getExcelfile = useCallback(async () => {
    // console.log("calenderDate ==> ", calenderDate);
    // console.log(
    //   "new format ==> ",
    //   `${calenderDate[1].$D}-${calenderDate[1].$M + 1}-${calenderDate[1].$y}`
    // );
    // setCalenderDate([null, null]);
    // console.log("date ==> ", data[0].$D, data[0].$M, data[0].$y);
    // calenderDate.start_date = "";
    // calenderDate.end_date = "";
    // location.relod();

    let temp = 0;
    // console.log("kkkk", calenderDate);
    calenderDate.map((d) => {
      if (d == null) {
        temp = 1;
      } else {
        temp = 0;
      }
      // console.log(temp)
    });
    // console.log(temp)
    if (temp == 1) {
      // console.log("any one of the dates is empty");

      toast(
        "Please choose both a start date and an end date before downloading contest submissions.",
        {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          type: "error",
        }
      );
      setCalenderDate([null, null]);
    } else {
      try {
        const startData = `${calenderDate[0].$D}_${calenderDate[0].$M}_${calenderDate[0].$y}`;
        const endDate = `${calenderDate[1].$D}_${calenderDate[1].$M}_${calenderDate[1].$y}`;
        // console.log(
        //   "Startdate=>",
        //   startData.split("_")[2] +
        //     startData.split("_")[1] +
        //     startData.split("_")[0]
        // );
        // console.log(
        //   "EndDate=>",
        //   endDate.split("_")[2] + endDate.split("_")[1] + endDate.split("_")[0]
        // );
        const month = parseInt(startData.split("_")[1]) + 1;
        // console.log("month", month+1)
        const StartDmonth = moment()
          .month(parseInt(startData.split("_")[1]))
          .format("MM");
        const EndDmonth = moment()
          .month(parseInt(endDate.split("_")[1]))
          .format("MM");

        const Startdate = moment()
          .date(parseInt(startData.split("_")[0]))
          .format("DD");
        const Enddate = moment()
          .date(parseInt(endDate.split("_")[0]))
          .format("DD");

        // console.log("Smonth=", moment().month(StartDmonth).format("MM"));
        // console.log("Emonth=", moment().month(EndDmonth).format("MM"));

        // const datee =startdata.split('/')[2] + startdate.split('/')[1] + startdate.split('/')[0]}-${enddate.split('/')[2] + enddate.split('/')[1] + enddate.split('/')[0]
        const response = await axios
          .get(
            `/users/download/excel/${calenderDate[0].$D}-${
              calenderDate[0].$M + 1
            }-${calenderDate[0].$y}
            /${calenderDate[1].$D}-${calenderDate[1].$M + 1}-${
              calenderDate[1].$y
            }`,
            { responseType: "blob" }
          )
          .then((res) => {
            // console.log("resssssssss  => ", res);
            let url = URL.createObjectURL(res.data);
            let a = document.createElement("a");
            a.href = url;

            a.setAttribute(
              "download",
              `Contest_Submission_${
                startData.split("_")[2] + StartDmonth + Startdate
              }_${endDate.split("_")[2] + EndDmonth + Enddate}.csv`
            );

            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
          });
        setCalenderDate([null, null]);
      } catch (error) {
        // console.log("Err=>", error);
        toast(
          "No contest submissions were found for that date range. Please choose another date range.",
          {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            type: "error",
          }
        );
      }
    }
    showPopup(false);
    setCalenderDate([null, null]);
  }, [calenderDate]);

  const handleDelete = (sportId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    }).then((res) => {
      if (res.isConfirmed) {
        setLoading(true);
        axios
          .delete(`/admin/deleteSport/${sportId}?force=true`)
          .then((res) => {
            toast.success("Sport deleted successfully!");
            setLoading(false);
            setCategoryData((current) =>
              current.filter((sport) => sport._id !== sportId)
            );
            setUpdate((prev) => !prev);
          })
          .catch((err) => {
            toast.error(
              err.response?.data?.message || "Failed to delete sport!"
            );
            setLoading(false);
          });
      }
    });
  };

  const columns = [
    {
      headerName: "Sport Logo",
      field: "sportLogo",
      style: {
        color: "red",
      },
      headerClass: "custom-header-class",
      headerStyle: { backgroundColor: "blue", fontSize: "30px" },
      cellRenderer: (params) => {
        //  console.log("Sport Logo URL:", params.data.sportLogo);
        return (
          <img
            className="img img-circle admin-sport-logo"
            height={50}
            width={50}
            style={{ margin: "4px" }}
            src={params.data.sportLogo}
            alt={params.data.sportLogo}
          />
        );
      },
      rowDrag: true,
      width: 92,
      suppressSizeToFit: true,
    },
    {
      headerName: "Sport Name",
      field: "sportName",
      minWidth: 120,
      flex: 1,
      cellRenderer: (params) => {
        //  console.log(params.data.sportName);
        return (
          <h5
            style={{ margin: "15px 0", color: "black", fontWeight: "lighter" }}
          >
            {params.data.sportName}
          </h5>
        );
      },
      headerClass: "custom-header-class",
    },
    {
      headerName: "Mobile App",
      field: "isAppActive",
      width: 98,
      suppressSizeToFit: true,
      cellRenderer: (params) => (
        <div style={{ marginTop: "10px", marginLeft: "0px", padding: "0" }}>
          <Switch
            id={params.data._id}
            checked={params.data.isAppActive}
            onChange={handleAppToggle}
          />
        </div>
      ),
      headerClass: "custom-header-class",
    },
    {
      headerName: "Website",
      field: "isWebsiteActive",
      width: 90,
      suppressSizeToFit: true,
      cellRenderer: (params) => (
        <div style={{ marginTop: "10px", marginLeft: "0px", padding: "0" }}>
          <Switch
            id={params.data._id}
            checked={params.data.isWebsiteActive}
            onChange={handleWebsiteToggle}
          />
        </div>
        //  <Switch
        //    id={params.data._id}
        //    checked={params.data.isWebsiteActive}
        //    onChange={handleWebsiteToggle}
        //    //  style={{margin: '20px'}}
        //  />
      ),
      headerClass: "custom-header-class",
    },
    {
      headerName: "Created",
      field: "createdAt",
      width: 104,
      suppressSizeToFit: true,
      cellRenderer: (params) => (
        <h5 style={{ margin: "15px 0", color: "black", fontWeight: "lighter" }}>
          {params.data.createdAt.split("T")[0]}
        </h5>
      ),
      headerClass: "custom-header-class",
    },
    {
      headerName: "Updated",
      field: "updatedAt",
      width: 104,
      suppressSizeToFit: true,
      cellRenderer: (params) => (
        <h5 style={{ margin: "15px 0", color: "black", fontWeight: "lighter" }}>
          {params.data.updatedAt.split("T")[0]}
        </h5>
      ),
      headerClass: "custom-header-class",
      //  valueFormatter: (params) => params.value.substring(0, 10),
    },
    {
      headerName: "Action",
      field: "action",
      width: 132,
      suppressSizeToFit: true,
      cellRenderer: (params) => (
        <div>
          <select
            onChange={(e) => handleSelect(e)}
            id={params.data._id}
            style={{
              border: "none",
              width: "104px",
              padding: "10px 0px",
              fontSize: ".9rem",
              outline: "none",
              background: "transparent",
              opacity: ".6",
              marginTop: "8px",
            }}
          >
            <option disabled selected>
              Manage
            </option>
            <option value="prediction">Predictions</option>
            <option value="ranking">Rankings</option>
            <option value="contest">Contest</option>
            <option value="headTohead">Head-to-Head</option>
            <option value="teamNames">Team Names</option>
            <option value="gameResult">Game Results</option>
            <option value="winners">Winners</option>
          </select>
        </div>
      ),
      headerClass: "custom-header-class",
    },
    {
      headerName: "Edit",
      field: "edit",
      width: 66,
      suppressSizeToFit: true,
      cellRenderer: (params) => (
        <i
          className="EditButton fa fa-edit fonts"
          onClick={() => handleEditButton(params.data._id)}
          style={{ color: "#2011a8", cursor: "pointer", marginTop: "15px" }}
        ></i>
      ),
      headerClass: "custom-header-class",
    },
    {
      headerName: "Delete",
      field: "delete",
      width: 76,
      suppressSizeToFit: true,
      cellRenderer: (params) => (
        <i
          onClick={() => handleDelete(params.data._id)}
          className=" fa fa-trash"
          style={{
            cursor: "pointer",
            color: "red",
            textAlign: "center",
            fontSize: "1.2rem",
            marginLeft: "15px",
            marginTop: "15px",
          }}
        ></i>
      ),
      headerClass: "custom-header-class",
    },
  ];

  //   const eventsPerPage = 10;
  //   const firstPage = pageNumber * eventsPerPage;
  //   const lastPage = firstPage - eventsPerPage;
  // useEffect(() => {
  //   const firstPage = pageNumber * eventsPerPage;
  //   const lastPage = pageNumber - eventsPerPage;
  //   setCategoryData(categoryData.events?.slice(lastPage, firstPage));
  // }, [categoryData.events, pageNumber]);

  // const nextPage=()=>{
  //   setPageNumber(
  //     pageNumber === categoryData.events.length / eventsPerPage
  //       ? pageNumber
  //       : pageNumber + 1
  //   );
  // }
  // const prevPage = ()=>{
  //   setPageNumber(pageNumber === 1 ? pageNumber : pageNumber - 1);
  // }
  const getCategoryData = useCallback(async () => {
    try {
      setLoading(true);
      axios
        .get(`/admin/getAllSportsCategory`)
        .then((res) => {
          setTotalRows(res.data.data.total);
          return res.data.data.result;
        })
        .then((data) => {
          // console.log("data", data);
          setCategoryData(data);
          setLoading(false);
        });
    } catch (error) {
      console.log("error", error);
    }
  }, [pageNumber, status, update, perPage]);

  const searchSports = useCallback(
    async (e) => {
      try {
        setLoading(true);
        // setSearch(se)
        // console.log(e.target.value);
        let search1 = e.target.value;
        // console.log(search1.startsWith("#"));
        if (search1.startsWith("#")) {
          setCategoryData([]);
          setTotalRows(0);
          setLoading(false);
        } else {
          await axios
            .get(`admin/getAllSportsCategory?search=${e.target.value}`)
            .then((res) => {
              // console.log(res.data.data.result);
              setCategoryData(res.data.data.result);
              setTotalRows(res.data.data.result.length);
              setLoading(false);
            });
        }

        // search1.split("#").map((i) => {
        //   if(i == ''){
        //     console.log("emplty");
        //   }
        //     setCategoryData("There are no records to display");
        //     setTotalRows(0);
        //     setLoading(false);
        // })
      } catch (error) {
        console.log(error);
      }
    },
    [pageNumber, status, update]
  );

  const handleDragNDrop = async (e) => {
    const previousOrder = [...categoryData];
    const reorderedItems = [];

    e.api.forEachNode((node) => {
      if (node.data) {
        reorderedItems.push(node.data);
      }
    });

    if (reorderedItems.length !== categoryData.length) {
      return;
    }

    setCategoryData(reorderedItems);
    try {
      const response = await axios.patch("/admin/reorderSports", {
        sportIds: reorderedItems.map((sport) => sport._id),
      });
      setCategoryData(response.data.data);
      toast.success("Sport order saved");
    } catch (error) {
      setCategoryData(previousOrder);
      toast.error(error.response?.data?.message || "Failed to save sport order");
    }
  };

  const handleDragEnd = async (event) => {
    console.log("ewrw");
    // setLoading(true);

    const { active, over } = event;

    if (active.id !== over.id) {
      const oldIndex = categoryData.findIndex((data) => data._id === active.id);
      const newIndex = categoryData.findIndex((data) => data._id === over.id);
      console.log(oldIndex, newIndex);
      // Reorder items locally
      const reorderedItems = arrayMove(categoryData, oldIndex, newIndex);
      setCategoryData(reorderedItems);
      try {
        await axios.patch(
          `/admin/changeSportsNumber/${oldIndex}/${newIndex}`,
          // { fromIndex: oldIndex, toIndex: newIndex },
          {
            headers: {
              // Authorization: `Bearer ${AUTH_TOKEN}`,
              "Content-Type": "application/json",
            },
          }
        );
        console.log("Item dragged successfully");
      } catch (error) {
        console.error("Error updating item order:", error.message);
        console.error("Error response data:", error.response?.data);
        console.error("Error response status:", error.response?.status);
        setCategoryData(categoryData);
      }
    }
  };

  const handlePageChange = (page) => {
    setPageNumber(page);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    console.log("pagination => ", newPerPage, page);
    setPageNumber(1);
    setperPage(newPerPage);
    console.log(page, " ", newPerPage);
  };

  // const handleDeleteConfirm = (row, type) => {
  //   setShowDeleteConfirm(true);
  //   setDeleteModelTitle(`Confirm ${type}`);
  //   setDeleteModelMessage(`Are you sure want to ${type} this category?`);
  //   setDeleteModelActionType(type);
  //   setIdBeingDeleting(row._id);
  // };

  const showDeleteModal = (type, id) => {
    alert("show delete modal");
  };

  const hideConfirmationModal = () => {
    setShowDeleteConfirm(false);
    setIdBeingDeleting(null);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") e.preventDefault();
    // console.log("key", e.key)
  };

  const submitDelete = async () => {
    setLoadingDeleteModel(true);
    setLoadingDeleteModelConfirmText("Deleting");
    //  activate deactivate user
    try {
      let res = await axios.delete(
        `/admin/advertisement/del/${idBeingDeleting}`
      );
      toast(res.data.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        type: "success",
      });
      setShowDeleteConfirm(false);
      setLoadingDeleteModel(false);
      setPageNumber(1);
      getCategoryData();
    } catch (errors) {
      toast(errors.response.data.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        type: "error",
      });
      setShowDeleteConfirm(false);
      setLoadingDeleteModel(false);
      setPageNumber(1);
      getCategoryData();
    }
  };

  useEffect(() => {
    getCategoryData();
    if (location.state) {
      let msg = location.state.message;
      window.history.replaceState({}, document.title);
      navigate(location.pathname, { replace: true });
      toast(msg, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        type: "success",
      });
    }
  }, [location, getCategoryData, pageNumber, perPage, update]);

  const customStyle = {
    header: {
      style: {
        border: "1px solid gray",
      },
    },
    headRow: {
      style: {
        fontSize: "1.2rem",
        border: "1px solid gray",
        backgroundColor: "#8180a6",
      },
    },
    rows: {
      style: {
        fontSize: "1.2rem",
        border: "1px solid gray",
      },
    },
    pagination: {
      style: {
        fontSize: "1.2rem",
        border: "1px solid gray",
        backgroundColor: "#8180a6",
      },
    },
  };

  //handle download
  const handleDownload = () => {
    console.log("calender date ==> ", calenderDate);
    axios
      .get(
        `users/download/excel/${calenderDate.start_date}/${calenderDate.end_date}`
      )
      .then((res) => res.data)
      .then(async (buffer) => {
        // data = new Uint8Array([data]);
        const byteArray = new Uint8Array(
          buffer.split("").map((char) => char.charCodeAt(0))
        );
        console.log("unit 8 array => ", byteArray);
        const byte = new Uint8Array([byteArray]);
        const blob = new Blob([byte], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "sports_category_report.xlsx";
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);

        // const response = await fetch(url);
        // const blob = await response.blob();
        // const urlObject = URL.createObjectURL(blob);

        // // Create a link and trigger the download
        // const a = document.createElement("a");
        // a.href = urlObject;
        // a.download = "sports_category_report.xlsx";
        // document.body.appendChild(a);
        // a.click();
        // document.body.removeChild(a);
        // URL.revokeObjectURL(urlObject);
      })
      .catch((error) => {
        // console.log("download excel error => ", error);
        toast.error(error.response?.data?.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      });
  };

  return (
    <>
      <Helmet>
        <title>Sports Categories</title>
      </Helmet>
      <LayoutPage>
        <div className="row">
          <div className="col-12">
            <div className="card my-4">
              <div className="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                <div
                  style={{
                    backgroundColor: "#46456e",
                  }}
                  className="shadow-primary border-radius-lg d-flex justify-content-between align-items-center p-2 px-4"
                >
                  <div className="d-flex pt-2">
                    <i
                      style={{ color: "#fff", cursor: "pointer" }}
                      className="fa fa-arrow-left fs-4"
                      onClick={() => {
                        navigate("/dashboard");
                      }}
                    ></i>
                    <h6 className="text-white text-capitalize ps-4 ">
                      Sports Categories
                    </h6>
                  </div>
                  <div className="search-box">
                    <form action="">
                      <input
                        type="search"
                        name="search"
                        id=""
                        placeholder="Search sports"
                        style={{
                          borderRadius: "5px",
                          width: "90%",
                          padding: "10px",
                        }}
                        onChange={searchSports}
                        onKeyDown={handleKeyDown}
                      />
                    </form>
                  </div>
                  <Link
                    to="/category/addcategory"
                    title="Add New"
                    className="admin-primary-button"
                  >
                    <AddCircleIcon className="pe fs-4" /> Add Sport
                  </Link>
                </div>
              </div>

              <div className="card-body px-0 pb-2">
                <div className="p-4">
                  <div className="admin-filter-panel">
                    <div className="admin-toolbar">
                      <div>
                        <h2 className="admin-filter-title">
                          Contest Submission Export
                        </h2>
                        <p className="admin-filter-help">
                          Choose a date range to download contest submissions as
                          CSV. The export behavior is unchanged.
                        </p>
                      </div>
                      <div className="d-flex align-items-center flex-wrap gap-3">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                      {/* <div>this is : {calenderDate.start}</div> */}
                      {/* <DemoContainer components={["DateRangePicker"]}> */}
                      {/* {calenderDate.start == "undefined" ? (
                        "hellooooooo"
                      ) : ( */}
                      <DateRangePicker
                        // maxDate={new Date()}
                        value={calenderDate}
                        localeText={{ start: "Start Date", end: "End Date" }}
                        onChange={(data) => {
                          // console.log("on change => ", data);

                          setCalenderDate(data);

                          // calenderDate.start_date = `${data[0]?.$D}-${
                          //   data[0]?.$M + 1
                          // }-${data[0]?.$y}`;
                          // calenderDate.end_date = `${data[1]?.$D}-${
                          //   data[1]?.$M + 1
                          // }-${data[1]?.$y}`;
                          // console.log("calenderDate ==> ", calenderDate);
                        }}
                      />
                      {/* )} */}

                      {/* </DemoContainer> */}
                        </LocalizationProvider>
                        <button
                          className="admin-primary-button"
                          onClick={getExcelfile}
                        >
                          Download CSV
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="table-responsive p-0 ag-theme-alpine">
                    {/* <div
                      className="ag-theme-alpine"
                      style={{
                        height: "510px",
                        width: "100%",
                        border: "2px solid red",
                      }}
                    > */}
                    <AgGridReact
                      rowData={categoryData}
                      columnDefs={columns}
                      defaultColDef={{
                        minWidth: 64,
                        resizable: true,
                      }}
                      headerHeight={60}
                      rowDragManaged={true}
                      rowHeight={60}
                      animateRows={true}
                      domLayout={"autoHeight"}
                      suppressMovableColumns={true}
                      onGridReady={(params) => params.api.sizeColumnsToFit()}
                      onGridSizeChanged={(params) => params.api.sizeColumnsToFit()}
                      onRowDragEnd={handleDragNDrop}
                      loading={loading}
                      overlayNoRowsTemplate='<span class="no-rows" style= "margin: 30px 0 0 0">No data found</span>'
                      // rowStyle={{padding:"17px",fontSize: "20px"}}
                    />
                    {/* </div> */}
                    {showDeleteConfirm && (
                      <DeleteConfirmation
                        showModalHandler={showDeleteModal}
                        confirmModalHandler={submitDelete}
                        hideModalHandler={hideConfirmationModal}
                        loadingConfirmButton={loadingDeleteModel}
                        loadingConfirmButtonText={loadingDeleteModelConfirmText}
                        modelTitle={deleteModelTitle}
                        actionButtonClass={"primary"}
                        actionType={deleteModelActionType}
                        message={deleteModelMessage}
                      />
                    )}
                  </div>
                </div>
              </div>

              {popup && (
                <div className="popQues" value={popup}>
                  <div className="confirmation">
                    <h3>Are you sure to Download the file?</h3>
                  </div>
                  <div className="confirm-btn">
                    <button
                      style={{
                        width: "250px",
                        height: "50px",
                        borderRadius: "10px",
                        backgroundColor: "orange",
                      }}
                      onClick={getExcelfile}
                    >
                      YES
                    </button>
                    <button
                      style={{
                        width: "250px",
                        height: "50px",
                        borderRadius: "10px",
                        backgroundColor: "orange",
                      }}
                      onClick={() => showPopup(false)}
                    >
                      NO
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </LayoutPage>
    </>
  );
}

export default Dnd;
